var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Treeselect,_vm._b({attrs:{"multiple":true,"flat":true,"default-expand-level":4,"normalizer":_setup.normalizer,"options":_setup.items,"disable-fuzzy-matching":"","value":_setup.selected},on:{"select":_setup.onSelect,"deselect":_setup.onDeSelect}},'treeselect',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }